import React, { useState, useEffect } from 'react';
import { useGetAll } from '../hooks/CambioLadaHook';
import {
  KTSVG,
  SimpleAlert,
  LoadingGrid,
  formatDateMonth,
  maskPhoneNumber,
} from '../../../../../_mexablock/helpers';
import { TableList } from '../../../../../_mexablock/helpers/components/TableList';
import {
  downloadExcel,
  downloadPDF,
} from '../../../../service/reportes/CambioLada';
import { parseAxiosError } from '../../../../service/reportes/AccountStatment';
import { Filter } from '../../activaciones/_modals/Filter';

let fechaActual = new Date();
let fecha_inicio_init = new Date(
  fechaActual.getFullYear(),
  fechaActual.getMonth() - 1,
  1
);
let fecha_fin_init = new Date();

const View: React.FC = () => {
  const [loadingView, setloadingView] = useState(true);
  const [initFilterValues, setInitFilterValues] = useState({
    rol_id: 0,
    code: '',
    init_date: '',
    end_date: '',
    filter: 0,
  });
  const [reloadGrid] = useState(Math.random() * 40);
  const { data, loadingRequest } = useGetAll(reloadGrid, initFilterValues);
  const [loadingDownload, setloadingDownload] = useState(false);
  const [loadingDownloadExcel, setloadingDownloadExcel] = useState(false);

  useEffect(() => {
    if (data.length) {
      setloadingDownload(false);
      setloadingDownloadExcel(false);
    } else {
      setloadingDownload(true);
      setloadingDownloadExcel(true);
    }
  }, [data]);

  useEffect(() => {
    if (loadingRequest > 0) {
      setloadingView(false);
    }
  }, [loadingRequest]);

  const handleFilter = (values: any) => {
    setInitFilterValues(values);
  };
  const handleFilterClean = () => {
    setInitFilterValues({
      rol_id: 0,
      code: '',
      init_date: '',
      end_date: '',
      filter: 0,
    });
  };

  const columns: any = [
    {
      id: 'createdAt',
      name: <div className="fw-bolder text-muted me-5">Fecha</div>,
      selector: (row: any) => formatDateMonth(row.createdAt),
      sortable: true,
    },

    {
      id: 'iccid',
      name: <div className="fw-bolder text-muted me-5">ICCID</div>,
      selector: (row: any) => row.iccid,
      width: '200px',
      sortable: true,
    },

    {
      id: 'old_msisdn',
      name: <div className="fw-bolder text-muted me-5">Número Ant.</div>,
      selector: (row: any) => maskPhoneNumber(row.old_msisdn.toString()),
      sortable: true,
    },

    {
      id: 'new_msisdn',
      name: <div className="fw-bolder text-muted me-5">Número Act.</div>,
      selector: (row: any) => maskPhoneNumber(row.new_msisdn.toString()),
      sortable: true,
    },

    {
      id: 'customer',
      name: <div className="fw-bolder text-muted me-5">Cliente</div>,
      selector: (row: any) =>
        `${row.customer.first_name} ${row.customer.father_last_name}`,
      sortable: true,
      width: '200px',
    },

    {
      id: 'creator',
      name: <div className="fw-bolder text-muted me-5">Usuario</div>,
      selector: (row: any) =>
        `${row.creator.first_name} ${row.creator.father_last_name}`,
      sortable: true,
      width: '200px',
    },
  ];

  const handleDownloadPDF = () => {
    setloadingDownload(true);
    setTimeout(() => {
      downloadPDF(initFilterValues)
        .then(() => {
          setloadingDownload(false);
        })
        .catch(async (error) => {
          setloadingDownload(false);
          const message = await parseAxiosError(error);
          SimpleAlert(message, 4000, 'error');
        });
    }, 2000);
  };

  const handleDownloadExcel = () => {
    setloadingDownloadExcel(true);
    setTimeout(() => {
      downloadExcel(initFilterValues)
        .then(() => {
          setloadingDownloadExcel(false);
        })
        .catch(async (error) => {
          setloadingDownloadExcel(false);
          const message = await parseAxiosError(error);
          SimpleAlert(message, 4000, 'error');
        });
    }, 2000);
  };

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              <Filter
                initFilterValues={initFilterValues}
                onCleanFilter={handleFilterClean}
                onSearchFilter={handleFilter}
                showFilterCode={true}
                noAuto={false}
              />
              <div className="card-toolbar">
                <div className="d-flex rounded mt-3">
                  <button
                    className="btn btn-sm btn-light-success"
                    disabled={loadingDownloadExcel}
                    onClick={() => handleDownloadExcel()}
                  >
                    {loadingDownloadExcel && data.length ? (
                      <span
                        className="indicator-progress"
                        style={{ display: 'block' }}
                      >
                        Descargando...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    ) : (
                      <>
                        <KTSVG
                          path="/media/icons/duotune/files/fil029.svg"
                          className="svg-icon-5 svg-icon-gray-500 me-1"
                        />
                        Descargar
                      </>
                    )}
                  </button>

                  <button
                    className="btn btn-sm btn-light-danger ms-5"
                    disabled={loadingDownload}
                    onClick={handleDownloadPDF}
                  >
                    {loadingDownload && data.length ? (
                      <span
                        className="indicator-progress"
                        style={{ display: 'block' }}
                      >
                        Descargando...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    ) : (
                      <>
                        <KTSVG
                          path="/media/icons/duotune/files/fil030.svg"
                          className="svg-icon-5 svg-icon-gray-500 me-1"
                        />
                        Descargar
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={data} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export { View };
